module.exports = __webpack_public_path__ + "img/logo-bold-old.06acd2c9.png";